module.exports = __webpack_public_path__ + "img/auction-sim-phone-browse.2c146352.png";